<template>
    <info-widget :collapsible="true" :is-expanded="expanded" @toggle_expand="$emit('toggle_expand')">
        <template v-slot:title>Tax Documents</template>

        <slot v-if="!$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.EMPLOYEE_TAX_DOCUMENTS_ROLES)">
            <div class="info-widget-empty p-2">
                This information is not available to your security role.
            </div>
        </slot>

        <slot v-if="$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.EMPLOYEE_TAX_DOCUMENTS_ROLES)">
            <div v-if="employee && taxForms.length">
                <section class="table-section" v-if="employee && taxForms.length">
                    <div class="table-wrapper table-responsive">
                        <table class="table css-table widget-table table-fixed">
                            <thead>
                                <tr>
                                    <th class="">Document</th>
                                    <th class="cw-6 cell-right">Year</th>
                                </tr>
                            </thead>
                            <tbody v-for="doc in visibleTaxForms" :key="doc.id" :class="{'active-item': doc.id == activeTaxDocumentId}">
                                <tr>
                                    <td>
                                        <a href @click.prevent="setCurrentRestrictedDoc(doc)">
                                            {{ doc.document_title }}
                                        </a>
                                    </td>
                                    <td class="cw-6 cell-right">
                                        <span>
                                            {{ doc.tax_year }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
                <div v-if="!showAllTaxForms && employee && taxForms.length > 5" class="pb-1">
                    <button type="button" class="btn btn-link btn-block" @click.prevent="showAllTaxForms = true">
                        See all
                    </button>
                </div>
                <div v-if="showAllTaxForms && employee && taxForms.length > 5" class="pb-1">
                    <button type="button" class="btn btn-link btn-block" @click.prevent="showAllTaxForms = false">
                        See fewer
                    </button>
                </div>
            </div>

            <div v-if="!taxForms.length">
                <div class="info-widget-empty p-2">
                    This employee has no tax documents.
                </div>
            </div>
        </slot>
    </info-widget>

    <view-document-modal :client-id="client.id" :doc="currentRestrictedDoc" v-if="currentRestrictedDoc" @submit="openRestrictedDoc(currentRestrictedDoc)" @close="currentRestrictedDoc = false"/>
    <pdf-modal :url="currentPDF.url" :title="currentPDF.title" v-if="currentPDF" @close="currentPDF = null" ref="pdfModal" />
    <w2-modal :client="client" :w2detail="currentW2" v-if="currentW2" ref="W2Modal" @close="currentW2 = null" />
</template>

<script>
import ButtonRow from '@/components/ButtonRow'
import InfoWidget from '@/components/InfoWidget'
import PdfModal from '@/components/PdfModal'
import W2Modal from '@/components/W2Modal'

import ViewDocumentModal from '@/components/EmployeeSidebar/ViewDocumentModal'

export default {
    components: {
        ButtonRow, InfoWidget, PdfModal, W2Modal,
        ViewDocumentModal,
    },
    props: ['employee', 'client', 'taxForms', 'activeTaxDocumentId', 'expanded'],
    emits: ['toggle_expand'],
    computed: {
        visibleTaxForms() {
            if (!this.showAllTaxForms) {
                return this.taxForms.slice(0, 5)
            }

            return this.taxForms
        },
    },
    data() {
        return {
            currentRestrictedDoc: null,
            currentPDF: null,
            currentW2: null,
            showAllTaxForms: Boolean(this.activeTaxDocumentId),
        }
    },
    methods: {
        setCurrentRestrictedDoc(doc) {
            this.currentRestrictedDoc = doc
        },
        openRestrictedDoc(doc) {
            this.currentRestrictedDoc = null
            // if it's a W2, open the modal; otherwise, open the PDF
            if (doc.document_type == 'w2') {
                this.currentW2 = doc
                this.$nextTick(() => {
                    this.$refs.W2Modal.open()
                })
            } else {
                this.currentPDF = {
                    title: doc.name,
                    url: {
                        url: doc.url,
                        withCredentials: true,
                    },
                }
            }
        },
    },
}
</script>
